export const normalizeString = (str: string) => str.trim().toLowerCase();
